import React from "react";
import { createRoot, Root } from "react-dom/client";
import { Box, CircularProgress } from "@mui/material";
import "./style.css";


const LLoading = () => {

  return (
    <div className="d-flex justify-content-start dimmers actives">
      <div className="w-100" style={{ minHeight: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      </div>
    </div>
  );
};

let loadingRoot: Root | null = null;
let previousOverflow: string | null = null;

const showLoading = () => {
  if (document.getElementById("loading")) return;

  previousOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";

  const div = document.createElement("div");
  div.id = "loading";
  document.body.appendChild(div);

  loadingRoot = createRoot(div);
  loadingRoot.render(<LLoading />);
};

const hideLoading = () => {
  const div = document.getElementById("loading");
  if (div && loadingRoot) {
    document.body.style.overflow = previousOverflow || "";
    loadingRoot.unmount();
    document.body.removeChild(div);
    loadingRoot = null;
  }
};

export { showLoading, hideLoading };
